"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _mobxReact = require("mobx-react");
var _Field = _interopRequireDefault(require("../Field"));
var _constants = require("../../constants");
var _styles = require("./styles");
var _FormattedComponents = require("../FormattedComponents");
var _posthogUtils = require("../../utils/posthog-utils");
var _posthogEvents = require("../../posthog-events");
var _messages = _interopRequireDefault(require("./messages"));
var _loginErrors = _interopRequireDefault(require("../../login-errors"));
var _PhoneInput = _interopRequireDefault(require("../PhoneInput"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var PhoneAndPasswordLoginError = function PhoneAndPasswordLoginError(_ref) {
  var errorResponse = _ref.errorResponse,
    forgotPasswordLink = _ref.forgotPasswordLink;
  var status = errorResponse.status,
    data = errorResponse.data;
  var renderedErrorConfig = [{
    shouldRender: status === 401 && data === 'invalid_password' || status === 403 && data === 'user_disabled',
    message: _messages["default"].wrongPhoneOrPassword
  }, {
    shouldRender: status === 401 && data === _loginErrors["default"].FIFTH_ATTEMPT,
    message: _messages["default"].wrongPhoneNumberOrPasswordFourTimes,
    values: {
      helpArticle: /*#__PURE__*/_react["default"].createElement(_styles.StyledLink, {
        href: _constants.helpArticleURL,
        target: "_blank"
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].helpArticle))
    }
  }, {
    shouldRender: status === 429 && data === _loginErrors["default"].TOO_MANY_REQUESTS,
    message: _messages["default"].wrongEmailOrPasswordTenTimes,
    values: {
      passwordResetLink: /*#__PURE__*/_react["default"].createElement(_styles.StyledLink, {
        href: forgotPasswordLink,
        target: "_blank"
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].passwordResetLink))
    }
  }, {
    shouldRender: status === 429 && data === _loginErrors["default"].TOO_MANY_CHANGE_REQUESTS,
    message: _messages["default"].wrongCurrent10thTime,
    values: {
      passwordResetLink: /*#__PURE__*/_react["default"].createElement(_styles.StyledLink, {
        href: forgotPasswordLink,
        target: "_blank"
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].passwordResetLink))
    }
  }, {
    shouldRender: status === 403 && data === _loginErrors["default"].NOT_ALLOWED_WORKSPACE,
    message: _messages["default"].doesNotHaveAccess
  }];
  var renderedError = renderedErrorConfig.find(function (element) {
    return element.shouldRender;
  });
  return renderedError ? /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorIcon, {
    name: 'warning'
  }), /*#__PURE__*/_react["default"].createElement(_styles.ErrorNotification, null, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _extends({}, renderedError.message, {
    values: renderedError.values
  })))) : null;
};
var PhoneAndPasswordLogin = function PhoneAndPasswordLogin(_ref2) {
  var intl = _ref2.intl,
    isMobile = _ref2.isMobile,
    form = _ref2.form,
    forgotPasswordLink = _ref2.forgotPasswordLink,
    onForgotPasswordClick = _ref2.onForgotPasswordClick,
    _onSubmit = _ref2.onSubmit,
    onAllSignInOptionsClick = _ref2.onAllSignInOptionsClick,
    errorResponse = _ref2.errorResponse,
    showErrorMessage = _ref2.showErrorMessage,
    isOnlyOneLoginOption = _ref2.isOnlyOneLoginOption,
    isLoading = _ref2.isLoading;
  var formatMessage = intl.formatMessage;
  var posthogEvent = _posthogEvents.posthogEvents.attemptEmailSignIn;
  var inputStyles = {
    Input: (0, _styles.getHeight)()
  };
  return /*#__PURE__*/_react["default"].createElement(_styles.LoginForm, {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      (0, _posthogUtils.posthogCapture)(posthogEvent);
      _onSubmit();
    }
  }, /*#__PURE__*/_react["default"].createElement(_styles.EmailWrapperDiv, null, /*#__PURE__*/_react["default"].createElement(_PhoneInput["default"], {
    form: form,
    field: "phoneNumber",
    hideError: true,
    placeholder: formatMessage(_messages["default"].phoneNumber)
  })), !form.$('phoneNumber').isValid && form.$('phoneNumber').isDirty && /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorIcon, {
    name: 'warning'
  }), /*#__PURE__*/_react["default"].createElement(_styles.ErrorNotification, null, formatMessage(_messages["default"].invalidPhoneNumber))), /*#__PURE__*/_react["default"].createElement(_Field["default"], {
    placeholder: formatMessage(_messages["default"].formField_domainPassword),
    field: "password",
    id: "password",
    type: "password",
    hideError: true,
    styles: inputStyles,
    form: form,
    onChange: function onChange(e) {
      return form.$('password').sync(e.target.value);
    },
    withPasswordToggle: true
  }), !isMobile && onForgotPasswordClick && /*#__PURE__*/_react["default"].createElement(_styles.StyledText, {
    alignText: 'right'
  }, /*#__PURE__*/_react["default"].createElement(_styles.StyledButtonLink, {
    onClick: onForgotPasswordClick
  }, formatMessage(_messages["default"].forgotYourPassword))), errorResponse && /*#__PURE__*/_react["default"].createElement(PhoneAndPasswordLoginError, {
    errorResponse: errorResponse,
    forgotPasswordLink: forgotPasswordLink
  }), /*#__PURE__*/_react["default"].createElement(_styles.StyledButton, {
    isMobile: isMobile,
    type: "submit",
    disabled: !form.isValid || isLoading
  }, formatMessage(_messages["default"].signIn), isLoading && /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
    size: "1rem"
  })), isMobile && /*#__PURE__*/_react["default"].createElement(_styles.StyledText, {
    isMobile: true,
    alignText: 'right'
  }, /*#__PURE__*/_react["default"].createElement(_styles.StyledButtonLink, {
    onClick: onForgotPasswordClick
  }, formatMessage(_messages["default"].forgotYourPassword))), !isMobile && !isOnlyOneLoginOption && /*#__PURE__*/_react["default"].createElement(_styles.StyledText, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledButtonLink, {
    onClick: onAllSignInOptionsClick
  }, /*#__PURE__*/_react["default"].createElement(_styles.StyledIcon, {
    name: 'arrow-left'
  }), formatMessage(_messages["default"].allSignInOptions))));
};
var _default = exports["default"] = (0, _reactIntl.injectIntl)((0, _mobxReact.observer)(PhoneAndPasswordLogin));
//# sourceMappingURL=index.js.map